import React, { useState } from 'react';
import api from '../../api/api';
import { Oval } from 'react-loader-spinner';

const SuspendClient = ({client}) => {
  const [onPending, setOnPending] = useState(false)

  const handleSuspend = async() => {

    try{

      setOnPending(true)
      
      await api.post('/owners/suspend', {
          clientId : client.id
      })

      setOnPending(false)
      window.location.reload();


    }catch(e){

      console.log(e)
      setOnPending(false)
        
    }
  };

  return (
    <div className="flex items-center justify-center h-screen ">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">

        <div className="flex items-center justify-center my-5">
          <img src={`${process.env.REACT_APP_API_PICTURE_URL}${client.picture}`} className='w-40 h-40 rounded-full'/>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-center text-gray-800">Suspendre {client.firstname}</h2>
  
        <div className="flex items-center justify-center my-5">
          <p className='text-sm text-center text-gray-700'>Vous etes sur le point de suspendre ce client, cela durera 2 semaines, il sera notifier de votre decision</p>
        </div>
        
        {!onPending && <div
          onClick={handleSuspend}
          className="flex items-center justify-center py-2 text-white transition duration-200 bg-indigo-600 rounded-lg cursor-pointer hover:bg-indigo-700"
        >
          Suspendre
        </div>}

        {onPending && 
          <div className="flex items-center justify-center">
            <Oval
              height={20}
              width={20}
              color="#ffffff"
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#cccccc"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </div>
        }

        
        
      </div>
    </div>
  );
};

export default SuspendClient;
